import { render } from "./TanaoroshiListPage.vue?vue&type=template&id=44340eb4"
import script from "./TanaoroshiListPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiListPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__